import { Component } from '@angular/core';
import { DevelopChallengeComponent } from '../develop-challenge.component';
import { CnAiService } from '../../challenges_service/cn-ai.service';

@Component({
  selector: 'app-develop-challenge-opportunities',
  templateUrl: './develop-challenge-opportunities.component.html',
  styleUrls: ['./develop-challenge-opportunities.component.scss']
})
export class DevelopChallengeOpportunitiesComponent {

  constructor(public developChallengeComponent: DevelopChallengeComponent, private aiService: CnAiService) {}

  openAiSidebar() {
    const context = this.developChallengeComponent?.selected_opp || [];
    this.aiService.openSidebar(
      'develop', 'opportunities', context,
      'Generate 5 opportunities {persona} that could arise from the solution. Current context: {context}',
      'opp_content', this.developChallengeComponent
    );
  }
}
